import AmbassadorBreadcrumb, {
  AmbassadorBreadcrumbLink,
} from "components/breadcrumbs/AmbassadorBreadcrumb";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes";
import edit from "assets/images/svgs/ambassador/edit-2.svg";
import Checkoutpoppup from "./components/Checkoutpoppup";
import Successpopup from "./components/Successpopup";
import useAmbassador from "containers/ambassador/useHooks";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { RedeemPrizePointsDTO } from "utils/helpers/models/ambassador/radeem-price-point.dto";
import useStore from "hooks/useStore";
import { warningToaster } from "utils/helpers/common/alert-service";
const RedeemPrizePoints = () => {

  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [showPopupsecond, setShowPopupSecond] = useState(false);
  const [deliveryAddress, setDeliveryAddress] = useState(() => {
    const storedData = localStorage.getItem("registeredData");
    if (!storedData) return "";

    try {
      const parsedData = JSON.parse(storedData);
      const user = parsedData?.user;
      const addressParts = [
        user?.address,
        user?.city,
        user?.state,
        user?.zipCode,
      ].filter(Boolean);

      return addressParts.join(", ");
    } catch (error) {
      return "";
    }
  });
  // const [consigneeNumber, setConsigneeNumber] = useState("");
  // const [shippingCompany, setShippingCompany] = useState("DHL");
  const [isEditingAddress, setIsEditingAddress] = useState(false);
  // Keep a stable object shape so derived calculations don't hit undefined during initial render.
  const [data, setData] = useState<any>({ products: [] })
  const { getAmbassadorProducts } = useAmbassador()
  const { postProductRequest, getProfileData } = useAmbassador()
  const { getAmbassadorWallet } = useStore();
  const wallet = getAmbassadorWallet();

  console.log(wallet);

  useEffect(() => {
    getAmbassadorProducts((res) => {
      const cartWithQty = res.products.map((item) => ({
        ...item,
        quantity: 0
      }));
      setData({ ...res, products: cartWithQty });
    });
  }, []);

  const selectedProducts = data?.products?.filter((item) => item.quantity > 0);
  const handleConfirm = async () => {
    if (!selectedProducts || selectedProducts.length === 0) {
      warningToaster("Please select at least one product.");
      return;
    }
    const totalPointsRequired = selectedProducts.reduce(
      (sum, item) => sum + item.cost * item.quantity,
      0
    );
    if (totalPointsRequired > wallet) {
      warningToaster("You don’t have enough points in your wallet.");
      return;
    }
    const payload: RedeemPrizePointsDTO = {
      products: selectedProducts.map((item) => ({
        productId: item.id,
        quantity: item.quantity,
      })),
      deliveryAddress,
    };

    postProductRequest(payload, setShowPopup, setShowPopupSecond);
    const profileResponse = await getProfileData()
    localStorage.setItem('registeredData', JSON.stringify(profileResponse));
  };

  const handleClose = () => {
    setShowPopupSecond(false);
    navigate(-1);
  };
  const breadcrumbLinks: AmbassadorBreadcrumbLink[] = [
    { title: "Home", path: siteRoutes.ambassadorHome },
    { title: "Wallet", path: siteRoutes.ambassadorWallet },
    {
      title: "Redeem Prize Points",
      path: siteRoutes.ambassadorRedeemPrizePoints,
    },
  ];


  const handleQuantityChange = (index: number, delta: number) => {
    setData((prevData) => {
      const updated = [...(prevData?.products ?? [])];
      if (!updated[index]) return prevData;
      const newQty = updated[index].quantity + delta;
      if (newQty >= 0) updated[index].quantity = newQty;
      return { ...prevData, products: updated };
    });
  };
  const subtotal =
    data?.products?.reduce((sum, item) => sum + item.cost * item.quantity, 0) ?? 0;
  const deliveryFee =
    data?.products?.reduce(
      (fee, item) =>
        item.shouldChargeDevliveryFee
          ? fee + item.deliveryFee * item.quantity
          : fee,
      0
    ) ?? 0;
  const total = subtotal + deliveryFee;


  return (
    <div className="min-h-screen container py-8">
      <AmbassadorBreadcrumb links={breadcrumbLinks} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-600">
            <thead className="font-medium text-2xl text-blackie border-b pb-2">
              <tr>
                <th className="py-3 pr-4" style={{ width: "50%" }}>
                  Product
                </th>
                <th className="py-3 pr-4">Prize</th>
                <th className="py-3 pr-4">Quantity</th>
                <th className="py-3 pr-4">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {data?.products?.map((item, i) => (
                <tr key={i} className="">
                  <td className="py-5 pr-4">
                    <div className="flex items-center gap-4">
                      <img
                        src={concatPathWithBackendUrl(item.image.name)}
                        className="w-14 h-14 object-contain rounded-md shadow"
                      />
                      <span className="text-black font-semibold text-sm">
                        {item.itemName}
                      </span>
                    </div>
                  </td>
                  <td className="py-5 pr-4 text-gray-700 font-medium">
                    {item.cost} pts
                  </td>
                  <td className="py-5 pr-4">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => handleQuantityChange(i, -1)}
                        className="w-5 h-5 bg-white border border-yellowText flex justify-center items-center text-yellowText rounded-full text-xs font-bold"
                      >
                        -
                      </button>
                      <span className="text-sm font-semibold w-5 text-center">
                        {item.quantity}
                      </span>
                      <button
                        onClick={() => handleQuantityChange(i, 1)}
                        className="w-5 h-5 bg-white border border-yellowText flex justify-center items-center text-yellowText rounded-full text-xs font-bold"
                      >
                        +
                      </button>
                    </div>
                  </td>
                  <td className="py-5 pr-4 text-gray-800 font-semibold">
                    {item.cost * item.quantity} pts
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Right - Cart Summary */}
        <div className="bg-white border rounded-xl p-6 sticky top-24">
          <h3 className="text-xl font-bold mb-5 text-center text-blackie">
            Cart Total
          </h3>

          <div className="flex justify-between text-sm mb-4  text-gray-700">
            <span>Subtotal</span>
            <span className="font-semibold">{subtotal} pts</span>
          </div>
          <div className="flex justify-between text-sm mb-4 text-gray-700">
            <span>Shipping</span>
            <span className="font-semibold">
              {deliveryFee === 0 ? "Free" : `$${Number(deliveryFee).toFixed(2)}`}
            </span>
          </div>
          <div className="flex justify-between text-sm font-bold text-blackie border-t pt-2">
            <span>Total</span>
            <span>{total} pts</span>
          </div>
          <div className="mb-4 text-sm text-gray-700">
            <span className="block font-medium mb-1">Shipping Info</span>
            {isEditingAddress ? (
              <div className="space-y-2">
                <input
                  type="text"
                  className="w-full border px-3 py-2 rounded outline-none focus:outline-none"
                  placeholder="Delivery Address"
                  value={deliveryAddress}
                  onChange={(e) => setDeliveryAddress(e.target.value)}
                />
                <button
                  onClick={() => setIsEditingAddress(false)}
                  className="text-sm text-blue-600 underline"
                >
                  Save
                </button>
              </div>
            ) : (
              <div className="flex justify-between gap-4 items-center px-3 py-2 rounded">
                <div>
                  <div>{deliveryAddress}</div> 
                </div>
                <button onClick={() => setIsEditingAddress(true)}>
                  <img src={edit} />
                </button>
              </div>
            )}
          </div>
          <div className="space-y-3 mb-4">
            {data.products
              ?.filter((item) => item.quantity > 0)
              .map((item, i) => (
                <div
                  key={i}
                  className="flex justify-between items-center bg-gray-50 px-4 py-2 rounded-lg"
                >
                  <div className="flex items-center gap-3">
                    <img
                      src={concatPathWithBackendUrl(item.image.name)}
                      alt={item.itemName}
                      className="w-8 h-8 object-contain"
                    />
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-gray-700">
                        {item.itemName}
                      </span>
                      <span className="text-xs font-medium text-gray-700">
                        Cost {item.cost} pts
                      </span>
                    </div>
                  </div>
                  <span className="text-sm font-semibold text-gray-800">
                    x{item.quantity}
                  </span>
                </div>
              ))}
          </div>
          <button
            className="w-full bg-primaryBlueText text-white py-3 rounded-full font-semibold text-sm"
            onClick={() => setShowPopup(true)}
          >
            Checkout
          </button>
        </div>
      </div>
      

      <Checkoutpoppup isOpen={showPopup} onClose={() => setShowPopup(false)} data={data?.products} handleConfirm={handleConfirm} />
      <Successpopup isOpen={showPopupsecond} onClose={handleClose} />

    </div>
  );
};

export default RedeemPrizePoints;